import { useEffect, useState } from "react";
import CustomHr from "../components/CustomHr";
import PageContainer from "../components/PageContainer";
import PageTitle from "../components/PageTitle";
import { useTranslation } from 'react-i18next';
import { useSelector } from "react-redux";
import Loader from '../components/Loader';
import Error from '../components/Error';
import { GreenButton } from '../components/buttons.js';

const SetUserData = () => {
    const { t } = useTranslation();
    const token = localStorage.getItem('ticino-wild-token');
    const { id } = useSelector(state => state.user);

    // Verifico all'atterraggio in pagina se è una edit
    const [inputData, setInputData] = useState({
        userId: id || null,
        firstName: null,
        lastName: null,
        phoneNumber: null,
        birthdate: null
    });
    const [editStatus, setEditStatus] = useState('idle');
    const [editError, setEditError] = useState(null);
    const { isUserPurchaseAvailable } = useSelector(state => state.user);
    const getUserData = async () => {
        setEditStatus('loading');
        const url = `${process.env.REACT_APP_SERVER_BASE_URL}/users/get-purchase-data/${id}`;
        const headers = { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` };
        const options = { method: 'GET', headers };
        try {
            const response = await fetch(url, options);
            if (response.ok) {
                const result = await response.json();
                if (result.isUserPurchaseAvailable) setInputData(prevState => ({ ...prevState, ...result.payload }));
                setEditStatus('succeeded');
            } else {
                const error = await response.json();
                throw new Error(error);
            }
        } catch (error) {
            setEditError(error.message || "Errore nella chiamata di verifica isEdit. Ricarica la pagina e riprova")
            setEditStatus('failed')
        }
    }
    useEffect(() => {
        if (isUserPurchaseAvailable) getUserData();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isUserPurchaseAvailable])

    // Gestisco la compilazione degli input
    const handleInputData = (event) => {
        const { id, value } = event.target;
        setInputData(prevState => ({
            ...prevState,
            [id]: value
        }))
    }

    // Invio i dati al backend
    const [fetchStatus, setFetchStatus] = useState('idle');
    const [error, setError] = useState(null);
    const sendData = async () => {
        setFetchStatus('loading');
        const url = `${process.env.REACT_APP_SERVER_BASE_URL}/users/set-purchase-data`;
        const headers = { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` };
        const options = { method: 'POST', headers, body: JSON.stringify(inputData) };
        try {
            const response = await fetch(url, options);
            if (response.ok) {
                setFetchStatus('succeeded');
            } else {
                const error = await response.json();
                throw new Error(error)
            }
        } catch (error) {
            setError(error.message || "Errore nell'invio dei dati al server. Ricarica la pagina e riprova.")
            setFetchStatus('failed')
        }
    }

    // Gestisco il redirect finale (se l'utente arriva da un tentativo di acquisto, sarà rimandato alla pagina dettaglio dell'esperienza che ha tentato di acquistare)
    const { link } = useSelector(state => state.backlink);

    useEffect(() => {
        if (fetchStatus === 'succeeded') {
            setTimeout(() => {
                window.location.href = link
            }, 3000)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [fetchStatus])

    // Verifico che tutti i campi siano compilati
    const [isAllFields, setIsAllFields] = useState(false);
    useEffect(() => {
        if(inputData.firstName && inputData.lastName && inputData.phoneNumber && inputData.birthdate) {
            setIsAllFields(true)
        } else {
            setIsAllFields(false)
        }
    }, [inputData])

    return (
        <PageContainer px="4" items="center">
            <PageTitle title={t('SetUserData.PageTitle')} backLink="/" />
            {
                editStatus === 'loading' &&
                <Loader />
            }
            {
                editStatus === 'failed' &&
                <Error message={editError} />
            }
            {
                (editStatus === 'succeeded' || editStatus === 'idle') &&
                <div className="flex flex-col items-center">
                    <h3 className="text-[#225424] my-8">{t('SetUserData.insertYourData')}</h3>
                    {/* Informazioni generali */}
                    <h2 className="mt-8">{t('SetUserData.personalData')}</h2>
                    <CustomHr />
                    <div className="flex flex-col w-full max-w-[400px]">

                        {/* Nome */}
                        <div className="flex flex-col p-2 gap-2">
                            <label htmlFor="companyName">{t('SetUserData.firstName')}</label>
                            <input type="text" id="firstName" value={inputData.firstName || null} onChange={handleInputData} />
                        </div>
                        {/* Cognome */}
                        <div className="flex flex-col p-2 gap-2">
                            <label htmlFor="companyName">{t('SetUserData.lastName')}</label>
                            <input type="text" id="lastName" value={inputData.lastName || null} onChange={handleInputData} />
                        </div>
                        {/* Telefono */}
                        <div className="flex flex-col p-2 gap-2">
                            <label htmlFor="companyName">{t('SetUserData.phoneNumber')}</label>
                            <input type="text" id="phoneNumber" value={inputData.phoneNumber || null} onChange={handleInputData} />
                        </div>
                        {/* Data di nascita */}
                        <div className="flex flex-col p-2 gap-2">
                            <label htmlFor="companyName">{t('SetUserData.birthdate')}</label>
                            <input type="date" id="birthdate" value={inputData.birthdate || null} onChange={handleInputData} />
                        </div>
                        <div className="ml-2 mt-8 w-full">
                            {
                                fetchStatus === 'idle' && isAllFields &&
                                <GreenButton text={t('SetUserData.sendButton')} click={sendData} />
                            }
                            {
                                fetchStatus === 'idle' && !isAllFields &&
                                <GreenButton disabled text={t('SetUserData.sendButton')} />
                            }
                            {
                                fetchStatus === 'loading' &&
                                <Loader />
                            }
                            {
                                fetchStatus === 'failed' &&
                                <Error message={error} />
                            }
                            {
                                fetchStatus === 'succeeded' &&
                                <div>
                                    <h3>{t('SetUserData.finalCopy')}</h3>
                                    <h4>{t('SetUserData.refresh')}</h4>
                                </div>
                            }
                        </div>
                    </div>
                </div>
            }
        </PageContainer>
    )
}

export default SetUserData